const Singleton = require('../../pattern/singleton');

/**
 * OS
 * @class
 * @extends Singleton
 */
class OS extends Singleton {

  /**
   * for IE9+
   * @static
   */
  static getInstance() {
    return this.__proto__.getInstance.call(this);
  }

  /**
   * @static
   * @return {object} regexp os
   */
  static get R_OS() {
    return {
      I_PHONE       : /\((iphone).*?os ([\d_]+).*?\)/,
      I_POD         : /\((ipod).*?os ([\d_]+).*?\)/,
      // I_PAD         : /\((ipad).*?os ([\d_]+).*?\)/,
      I_PAD         : /\((ipad).*?\).*?version\/([\d\.]+).*?/,
      ANDROID_MOBILE: /\(.*?(android) ([\d\.]+).*?\).*?(mobile)/,
      ANDROID       : /\(.*?(android) ([\d\.]+).*?\)/,
      WINDOWS_PHONE : /\(.*?(windows phone).*?[OS]? ([\d\.]+).*?\)/,
      BLACK_BERRY   : /.*?(blackberry).*?version\/([\d\.]+).*?/,
      MAC           : /\(.*?(mac) os .*?([\d_\.]+).*?\)/,
      LINUX         : /\(.*?(linux).*\)/,
      WINDOWS       : /\(.*?(windows).*?([\d_\.]+).*?\)/,
    }
  }

  /**
   * @instance
   */
  constructor() {
    super();

    const ua = window.navigator.userAgent.toLowerCase();

    const [ {}, name, version, mobile ] =
      OS.R_OS.I_PHONE.exec(ua) ||
      OS.R_OS.I_POD.exec(ua) ||
      OS.R_OS.I_PAD.exec(ua) ||
      OS.R_OS.ANDROID_MOBILE.exec(ua) ||
      OS.R_OS.ANDROID.exec(ua) ||
      OS.R_OS.WINDOWS_PHONE.exec(ua) ||
      OS.R_OS.BLACK_BERRY.exec(ua) ||
      OS.R_OS.MAC.exec(ua) ||
      OS.R_OS.WINDOWS.exec(ua) ||
      OS.R_OS.LINUX.exec(ua) ||
      []

    if(name) {
      this.os = name;
      if( typeof version !== 'undefined' && version !== null ) {
        this.version = version.split('_').join('.');
      } else {
        this.version = '';
      }
      const number = parseInt(this.version, 10);
      if(!isNaN(number)) {
        this.versionNumber = number;
      }
      this.ios     = name.match(/iphone|iopd|ipad/) ? true : false;
      this.android = name.match(/android/) ? true : false;
      if( name.match(/iphone|ipod|windows phone|blackberry/) ||
          (name.match(/android/) && mobile) ) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
      if( name.match(/ipad/) ||
          (name.match(/android/) && !mobile) ) {
        this.tablet = true;
      } else {
        this.tablet = false;
      }
    }
  }

}

/**
 * class exports
 */
module.exports = OS;



/** WEBPACK FOOTER **
 ** ./webpack/requires/models/environ/os.js
 **/